var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import "./questPlay.scrollcontainer.css";
function getDefaultScrollBarWidth() {
    // https://stackoverflow.com/a/13382873
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";
    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    // remove divs
    document.body.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}
var MY_SCROLL_WIDTH = 15;
var WORKAROUND_GAP = 5;
/**
 * This component is a container with own scrollbar
 * It takes 100% height
 *
 * Currently it is not using resize observer so use key prop to force rerender
 * Same applies to scrollToTop - just use key prop
 */
export var ScrollableContainer = function (_a) {
    var children = _a.children, forceMeRecalculateHeight = _a.forceMeRecalculateHeight;
    var browserScrollWidth = React.useMemo(function () { return getDefaultScrollBarWidth() + WORKAROUND_GAP; }, []);
    var ref = React.useRef(null);
    var _b = __read(React.useState(null), 2), barTop = _b[0], setBarTop = _b[1];
    var _c = __read(React.useState(null), 2), barHeight = _c[0], setBarHeight = _c[1];
    var updateBarHeight = React.useCallback(function () {
        var div = ref.current;
        if (!div) {
            return;
        }
        var ratio = div.clientHeight / div.scrollHeight;
        if (ratio < 1) {
            setBarHeight(Math.round(div.clientHeight * ratio));
        }
        else {
            setBarHeight(null);
        }
    }, [forceMeRecalculateHeight]);
    // TODO: Maybe add mutation or resize observer?
    React.useEffect(function () { return updateBarHeight(); }, [updateBarHeight]);
    var updateBarTop = React.useCallback(function () {
        var div = ref.current;
        if (!div) {
            return;
        }
        //const ratio = div.scrollTop / (div.scrollHeight - div.clientHeight);
        var ratio = div.scrollTop / div.scrollHeight;
        setBarTop(Math.round(div.clientHeight * ratio));
    }, []);
    React.useEffect(function () { return updateBarTop(); }, [updateBarTop]);
    //console.info("render", barHeight, barTop);
    React.useEffect(function () {
        var onResize = function () {
            updateBarHeight();
            updateBarTop();
        };
        window.addEventListener("resize", onResize);
        return function () {
            window.removeEventListener("resize", onResize);
        };
    }, [updateBarHeight, updateBarTop]);
    var isMouseDown = React.useRef(false);
    React.useEffect(function () {
        var onMouseUp = function () {
            isMouseDown.current = false;
        };
        document.addEventListener("mouseup", onMouseUp);
        return function () {
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, []);
    React.useEffect(function () {
        var onMouseMove = function (e) {
            // console.info("kek", isMouseDown.current, ref.current);
            if (!isMouseDown.current) {
                return;
            }
            var div = ref.current;
            if (!div) {
                return;
            }
            var scrollTopChange = (e.movementY * div.scrollHeight) / div.clientHeight;
            div.scrollTop += scrollTopChange;
        };
        document.addEventListener("mousemove", onMouseMove);
        return function () {
            document.removeEventListener("mousemove", onMouseMove);
        };
    });
    // A workaround with small overflow to hide browser scrollbar
    return (React.createElement("div", { style: { height: "100%", overflow: "hidden", position: "relative" } },
        React.createElement("div", { style: {
                height: "100%",
                width: "calc(100% + " + browserScrollWidth + "px)",
                paddingRight: browserScrollWidth + (barTop !== null && barHeight !== null ? MY_SCROLL_WIDTH : 0),
                overflowY: "scroll",
            }, onScroll: updateBarTop, ref: ref }, children),
        barTop !== null && barHeight !== null && (React.createElement("div", { style: {
                position: "absolute",
                right: 0,
                width: MY_SCROLL_WIDTH,
                top: barTop,
                height: barHeight,
                userSelect: "none",
            }, className: "rcs-inner-handle", onMouseDown: function (e) {
                isMouseDown.current = true;
            } }))));
};
//# sourceMappingURL=data:application/json;base64,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